import './../_node_modules/common-tags/es/TemplateTag/TemplateTag.js';
import './../_node_modules/common-tags/es/commaLists/commaLists.js';
import './../_node_modules/common-tags/es/commaListsAnd/commaListsAnd.js';
import './../_node_modules/common-tags/es/commaListsOr/commaListsOr.js';
import './../_node_modules/common-tags/es/html/html.js';
import './../_node_modules/common-tags/es/safeHtml/safeHtml.js';
import './../_node_modules/common-tags/es/oneLine/oneLine.js';
import './../_node_modules/common-tags/es/oneLineTrim/oneLineTrim.js';
import './../_node_modules/common-tags/es/oneLineCommaLists/oneLineCommaLists.js';
import './../_node_modules/common-tags/es/oneLineCommaListsOr/oneLineCommaListsOr.js';
import './../_node_modules/common-tags/es/oneLineCommaListsAnd/oneLineCommaListsAnd.js';
import './../_node_modules/common-tags/es/inlineLists/inlineLists.js';
import './../_node_modules/common-tags/es/oneLineInlineLists/oneLineInlineLists.js';
import stripIndent from './../_node_modules/common-tags/es/stripIndent/stripIndent.js';
import './../_node_modules/common-tags/es/stripIndents/stripIndents.js';
import prettier from "prettier";
const format = async (source, filePath, options) => {
  let formatted = stripIndent(source);
  const prettierOptions = await prettier.resolveConfig(filePath);
  formatted = await prettier.format(formatted, {
    ...prettierOptions,
    filepath: filePath,
    ...{}
  });
  return formatted;
};
export {
  format
};
//# sourceMappingURL=format.js.map
